<template>
  <v-main>
    <v-container>
      <v-card elevation="6">
        <v-card-title>
          <v-btn class="mx-2" fab small color="primary" to="/notifications">
            <v-icon dark> mdi-arrow-left </v-icon> </v-btn
          >Edit Notification
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col sm="4">
              <v-textarea
                v-model="form.description"
                outlined
                label="Name"
                prepend-inner-icon="mdi-alarm-bell"
                :error-messages="errors.description"
              ></v-textarea>
            </v-col>
          </v-row>
          <v-progress-circular
            v-if="isLoading"
            indeterminate
            color="primary"
          ></v-progress-circular>
          <v-btn v-else color="primary" dark @click="update">
            Update Notification
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      form: {},
      isLoading: false,
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      this.isLoading = true;
      let form = await axios.get(
        `/notifications/${this.$route.params.notificationId}`
      );
      this.form = form.data.data;
      this.isLoading = false;
    },
    async update() {
      try {
        this.isLoading = true;
        this.form.user_id = this.user.id;

        await axios.patch(
          `/notifications/${this.$route.params.notificationId}`,
          this.form
        );
        this.isLoading = false;
        this.$router.push("/notifications");
      } catch (e) {
        this.isLoading = false;
      }
    },
  },
};
</script>
